<template>
  <form novalidate @submit.prevent="handleSubmitForgotPassword">
    <h2 class="login__title">{{ $t(`${namespace}.title`) }}</h2>
    <p class="form__text">{{ $t(`${namespace}.text`) }}</p>

    <FormTextField
      v-model="form.recoveryEmail"
      type="email"
      :label="$t(`${namespace}.form.emailLabel`)"
      :placeholder="$t(`${namespace}.form.emailPlaceholder`)"
      :disabled="submitted"
      :name="$t(`${namespace}.form.emailName`)"
      :v-validate="{ required: true, email: true }"
    />

    <v-layout align-center justify-center fill-height>
      <v-flex xs6>
        <a
          class="text--link accent--text"
          :title="$t(`${namespace}.iRememberedMyPassword`)"
          @click.prevent="toggleForm"
        >
          {{ $t(`${namespace}.iRememberedMyPassword`) }}
        </a>
      </v-flex>

      <v-flex xs6>
        <Button
          type="submit"
          color="secondary"
          gradient
          :disabled="submitted"
          :loading="submitted"
          block
          large
        >
          {{ $t(`${namespace}.form.submitButton`) }}
        </Button>
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'
import session from '@/services/modules/session'

export default {
  name: 'ForgotPasswordForm',
  data () {
    return {
      namespace: 'Components.ForgotPasswordForm',
      form: {
        recoveryEmail: null
      },
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    toggleForm () {
      this.$emit('toggleForm')
    },

    setSubmittedValue (boolean = true) {
      this.submitted = boolean
    },

    async handleSubmitForgotPassword () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      this.setSubmittedValue(true)

      try {
        const { data: res } = await session.forgotPassword(this.form.recoveryEmail)

        if (!res.valid) {
          this.showAlert({
            type: 'error',
            message: res.message
          })

          this.form.recoveryEmail = null
        } else {
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.sendEmailSuccess`)
          })

          this.toggleForm()
        }
      } catch (error) {
        catchError(error)
        this.showAlert({
          type: 'error',
          message: this.$t('Common.genericError')
        })
      }

      this.setSubmittedValue(false)
    }
  }
}
</script>
